'use client';

import {
	Button,
	SimpleGrid,
	Stack,
	Text,
} from '@chakra-ui/react';
import { useLocale } from 'next-intl';

import { APP_ROUTES } from '@/routes';
import { CardHoverWrapper } from '../../components';
import { NextImageWithSkeleton } from '@packages/chakra-v3';
import { useRouter } from 'next/navigation';
import { CustomPortableText } from '@/modules/sanity-studio/components';
import { type GalleryPage } from '@/modules/sanity-studio/types';
import { SanityImageBuilder } from '@/modules/sanity-studio/utils/image-builder';
import { DefaultStyle } from '@packages/wastic-shared';

type WasticFolksContainerProps = {
	galleryPage: GalleryPage;
};

const WasticFolksContainer = ({ galleryPage }: WasticFolksContainerProps) => {
	const router = useRouter();
	const locale = useLocale() as 'en' | 'th';

	const handleGoToSustainableMove = () => router.push(APP_ROUTES.ABOUT.SUSTAINABLE_MOVE);

	return (
		<Stack gap={DefaultStyle.CONTENT_GAP}>
			<Stack gap={DefaultStyle.GRID_GAP}>
				<Text textAlign={'center'} textStyle={'h2'} w={'100%'}>{galleryPage.title[locale]}</Text>
				<SimpleGrid
					columns={{
						base: 2,
						lg:   3,
					}}
					gap={DefaultStyle.GRID_GAP}
				>
					{galleryPage.gallery?.map(item => (
						<CardHoverWrapper key={item._key} title={item.title[locale]!}>
							<NextImageWithSkeleton
								alt={item.title[locale]!}
								aspectRatio={'square'}
								src={SanityImageBuilder.for(item.image)?.url() ?? ''}
							/>
						</CardHoverWrapper>
					))}
				</SimpleGrid>
			</Stack>
			<Stack
				alignItems={'center'}
				bg={'gray.900'}
				borderRadius={12}
				gap={DefaultStyle.SMALL_SECTION_GAP}
				p={8}
			>
				<Stack gap={DefaultStyle.SMALL_GAP}>
					<Text color={'white'} textAlign={'center'} textStyle={'h4'}>
						{galleryPage.sustainableMove.title[locale]}
					</Text>
					<CustomPortableText
						color={'white'}
						textAlign={'center'}
						textStyle={'p3'}
						value={galleryPage.sustainableMove.description[locale] as never}
						w={'min(60ch, 100%)'}
					/>
				</Stack>
				<Button onClick={handleGoToSustainableMove}>
					Shop Collection
				</Button>
			</Stack>
		</Stack>
	);
};

export default WasticFolksContainer;